import { render, staticRenderFns } from "./AddNotaryModal.vue?vue&type=template&id=3896b718"
import script from "./AddNotaryModal.vue?vue&type=script&lang=js"
export * from "./AddNotaryModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports